import React, { useEffect, useState } from "react";
import { fetchYearsForSlider } from "../../../utils/addingLayers/AddVoltagesLayers";
import MVHierarchy from "./MVHierarchy";
import "./MV.css";
import useSync3DLayers from "../../../utils/useSync3DLayers";
import { toggleLayerHelper, handleSidebarClose } from "../layersUtils";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

function MediumVoltage({ setWfsLayers, setHoverInfo, handleClickInfo, setWmsLayers, handleSidebarToggle, handleSubstationOptions, substationOptions, closeSidebar, wfsLayers, viewState, setViewState, setOverlay, id_terenske_jedinice, setNetworkType }) {
    const [isRevisionActive, setIsRevisionActive] = useState(false);
    const [isTrafostaniceActive, setIsTrafostaniceActive] = useState(false);
    const [filterYear, setFilterYear] = useState(null);
    const [years, setYears] = useState([]);
    const [isDalekovodActive, setIsDalekovodActive] = useState(false);
    const [isHijerarhijaActive, setIsHijerarhijaActive] = useState(false);
    const [checkStubovi, setCheckStubovi] = useState(false);
    const [isStuboviActive, setIsStuboviActive] = useState(false);
    const netType = "srednjenaponska";

    useEffect(() => {
        setNetworkType(netType);
    }, [netType]);

    useEffect(() => {
        setIsTrafostaniceActive(wfsLayers.some(layer => layer.id.startsWith("trafo_stanice")));
    }, [wfsLayers]);

    useEffect(() => {
        const fetchYears = async () => {
            const fetchedYears = await fetchYearsForSlider();
            setYears(fetchedYears);
            setFilterYear(fetchedYears[0]);
        };

        fetchYears();

        handleSubstationOptions({ broj_korisnika_ts: { checked: false }, saidi_ts: { checked: false }, saifi_ts: { checked: false }, aktivne_ts: { checked: false }, gubici_ts: { checked: false } });
    }, []);

    const toggleLayer = async (checked, layerName, networkType = netType) => {
        const yearToFilter = isRevisionActive ? filterYear : null;
        return toggleLayerHelper({
            checked,
            layerName,
            networkType,
            wfsLayers,
            setWfsLayers,
            setWmsLayers,
            setHoverInfo,
            handleClickInfo,
            yearToFilter,
            viewState,
            setViewState,
            setOverlay,
            id_terenske_jedinice,
            setNetworkType
        });
    };

    const toggleRevision = (checked) => {
        setIsRevisionActive(checked);
        setFilterYear(checked && years.length > 0 ? years[0] : null);
    };

    useSync3DLayers({ wfsLayers, setWfsLayers, setWmsLayers, setHoverInfo, handleClickInfo, viewState, setViewState, setOverlay, id_terenske_jedinice, netType });

    const handleCloseSidebar = () => {
        handleSidebarClose({
            checkFlag: checkStubovi,
            setFlags: [setIsHijerarhijaActive, setIsStuboviActive, setIsDalekovodActive, setCheckStubovi],
            layerPrefixes: ["vod", "dionica", "stubovi"],
            setWfsLayers,
            setWmsLayers,
            closeSidebar,
            handleSidebarToggle,
            netType
        });
    };

    useEffect(() => {
        if (isHijerarhijaActive) {
            const alreadyExists = wfsLayers.some(layer => layer.id === "stubovi-srednjenaponska-layer");
            if (!alreadyExists) {
                toggleLayer(true, "stubovi", netType);
            }
        }
    }, [isHijerarhijaActive]);

    useEffect(() => {
        if (
            isHijerarhijaActive &&
            wfsLayers.some(layer => layer.id === "stubovi-srednjenaponska-layer")
        ) {
            handleSidebarToggle(() => (
                <MVHierarchy
                    isDalekovodActive={isDalekovodActive}
                    wfsLayers={wfsLayers}
                    setWfsLayers={setWfsLayers}
                    setHoverInfo={setHoverInfo}
                    handleClickInfo={handleClickInfo}
                    setWmsLayers={setWmsLayers}
                    viewState={viewState}
                    setViewState={setViewState}
                    setOverlay={setOverlay}
                    id_terenske_jedinice={id_terenske_jedinice}
                />
            ));
        } else if (isStuboviActive && !isHijerarhijaActive && isDalekovodActive) {
            handleCloseSidebar();
        }
    }, [isHijerarhijaActive, wfsLayers]);


    useEffect(() => {
        const handles = document.querySelectorAll('.rc-slider-handle');
        if (handles.length > 0) {
            handles[0].setAttribute('data-value', filterYear);
        }
    }, [filterYear]);

    return (
        <div className="medium-voltage">
            <span>
                <h5>Srednjenaponska mreža</h5>
            </span>

            <div>
                <div className="section">
                    <label className="toggle">
                        <span>Revizioni zapisi</span>
                        <input
                            type="checkbox"
                            checked={isRevisionActive}
                            onChange={(e) => toggleRevision(e.target.checked)}
                        />
                        <span className="slider"></span>
                    </label>
                    {isRevisionActive && (
                        <div className="slider-container">
                            <Slider
                                min={Math.min(...years)}
                                max={Math.max(...years)}
                                step={1}
                                value={filterYear}
                                onChange={(value) => setFilterYear(value)}
                                trackStyle={{ backgroundColor: '#00c897', height: 6 }}
                                railStyle={{ backgroundColor: '#34495e', height: 6 }}
                                handleStyle={{
                                    borderColor: '#00c897',
                                    backgroundColor: '#fff',
                                    width: 18,
                                    height: 18,
                                    marginTop: -6,
                                    position: 'relative',
                                    zIndex: 2
                                }}
                            />
                            <div className="year-labels">
                                <span>{Math.min(...years)}</span>
                                <span>{Math.max(...years)}</span>
                            </div>
                        </div>

                    )}
                </div>
                <label className="toggle">
                    <span>Stubovi</span>
                    <input
                        type="checkbox"
                        checked={wfsLayers.some(layer => layer.id.startsWith("stubovi-srednjenaponska"))}
                        onChange={(e) => {
                            toggleLayer(e.target.checked, "stubovi", "srednjenaponska");
                            setIsStuboviActive(e.target.checked);
                        }}
                    />
                    <span className="slider"></span>
                </label>

                <label className="toggle">
                    <span>Dalekovodi</span>
                    <input
                        type="checkbox"
                        checked={wfsLayers.some(layer => layer.id.startsWith("vod-srednjenaponska"))}

                        onChange={async (e) => {
                            toggleLayer(e.target.checked, "vod", "srednjenaponska");
                            setIsDalekovodActive(e.target.checked);
                        }}
                    />
                    <span className="slider"></span>
                </label>
                {isDalekovodActive && (
                    <div className="brojila-options">
                        <label className="toggle">
                            <span>Hijerarhija</span>
                            <input
                                type="checkbox"
                                checked={isHijerarhijaActive}
                                onChange={(e) => {
                                    const checked = e.target.checked;

                                    setIsHijerarhijaActive(checked);
                                    setCheckStubovi(checked);

                                    if (!checked) {
                                        handleCloseSidebar();
                                    }
                                }}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>
                )}
                <div className="section">
                    <label className="toggle">
                        <span>Trafostanice</span>
                        <input
                            type="checkbox"
                            checked={wfsLayers.some(layer => layer.id.startsWith("trafo_stanice"))}
                            onChange={(e) => {
                                toggleLayer(e.target.checked, "trafo_stanice");
                                setIsTrafostaniceActive(e.target.checked);
                            }}
                        />
                        <span className="slider"></span>
                    </label>
                    {isTrafostaniceActive && (
                        <div className="trafostanice-options">
                            <label className="toggle">
                                <span>Broj korisnika TS</span>
                                <input type="checkbox" checked={substationOptions.broj_korisnika_ts.checked} onChange={(e) => handleSubstationOptions({ broj_korisnika_ts: { checked: e.target.checked }, saidi_ts: { checked: substationOptions.saidi_ts.checked }, saifi_ts: { checked: substationOptions.saifi_ts.checked }, aktivne_ts: { checked: substationOptions.aktivne_ts.checked }, gubici_ts: { checked: substationOptions.gubici_ts.checked } })} />
                                <span className="slider"></span>
                            </label>
                            <label className="toggle">
                                <span>Pouzdanost distrib. sistema</span>
                            </label>
                            <div className="nested-section">
                                <label className="toggle">
                                    <span>SAIDI (Dalekovod/TS)</span>
                                    <input type="checkbox" checked={substationOptions.saidi_ts.checked} onChange={(e) => handleSubstationOptions({ broj_korisnika_ts: { checked: substationOptions.broj_korisnika_ts.checked }, saidi_ts: { checked: e.target.checked }, saifi_ts: { checked: substationOptions.saifi_ts.checked }, aktivne_ts: { checked: substationOptions.aktivne_ts.checked }, gubici_ts: { checked: substationOptions.gubici_ts.checked } })} />
                                    <span className="slider"></span>
                                </label>
                                <label className="toggle">
                                    <span>SAIFI (Dalekovod/TS)</span>
                                    <input type="checkbox" checked={substationOptions.saifi_ts.checked} onChange={(e) => handleSubstationOptions({ broj_korisnika_ts: { checked: substationOptions.broj_korisnika_ts.checked }, saidi_ts: { checked: substationOptions.saidi_ts.checked }, saifi_ts: { checked: e.target.checked }, aktivne_ts: { checked: substationOptions.aktivne_ts.checked }, gubici_ts: { checked: substationOptions.gubici_ts.checked } })} />
                                    <span className="slider"></span>
                                </label>
                            </div>
                            <label className="toggle">
                                <span>Očitavanje brojila TS</span>
                                <input type="checkbox" checked={substationOptions.aktivne_ts.checked} onChange={(e) => handleSubstationOptions({ broj_korisnika_ts: { checked: substationOptions.broj_korisnika_ts.checked }, saidi_ts: { checked: substationOptions.saidi_ts.checked }, saifi_ts: { checked: substationOptions.saifi_ts.checked }, aktivne_ts: { checked: e.target.checked }, gubici_ts: { checked: substationOptions.gubici_ts.checked } })} />
                                <span className="slider"></span>
                            </label>
                            <label className="toggle">
                                <span>Gubici na TS</span>
                                <input type="checkbox" checked={substationOptions.gubici_ts.checked} onChange={(e) => handleSubstationOptions({ broj_korisnika_ts: { checked: substationOptions.broj_korisnika_ts.checked }, saidi_ts: { checked: substationOptions.saidi_ts.checked }, saifi_ts: { checked: substationOptions.saifi_ts.checked }, aktivne_ts: { checked: substationOptions.aktivne_ts.checked }, gubici_ts: { checked: e.target.checked } })} />
                                <span className="slider"></span>
                            </label>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default MediumVoltage;